import styled from 'styled-components';
import theme from 'styled-theming';
import { prefix } from '../../tools/settings';
var borderStyles = {
  backgroundColor: {
    resting: 'var(--dentsu-color-n500)',
    hover: 'var(--dentsu-color-n500)',
    selected: 'var(--dentsu-color-blue)',
    disabled: theme('mode', {
      light: 'var(--dentsu-color-n250)',
      grey: 'var(--dentsu-color-n350)'
    }),
    hasError: 'var(--dentsu-color-red)'
  }
};
var surfaceStyles = {
  backgroundColor: {
    resting: theme('mode', {
      light: 'var(--dentsu-color-n50)',
      grey: 'var(--dentsu-color-n50)'
    }),
    hover: theme('mode', {
      light: 'var(--dentsu-color-n100)',
      grey: 'var(--dentsu-color-150)'
    }),
    selected: theme('mode', {
      light: 'var(--dentsu-color-n50)',
      grey: 'var(--dentsu-color-white)'
    }),
    disabled: 'var(--dentsu-color-white)',
    hasError: 'var(--dentsu-color-r100)'
  }
};
var checkStyles = {
  color: {
    resting: 'var(--dentsu-color-white)',
    hover: 'var(--dentsu-color-n350)',
    selected: 'var(--dentsu-color-b550)',
    disabled: 'var(--dentsu-color-n200)',
    hasError: 'var(--dentsu-color-n700)'
  }
};
var VisualPicker = styled.div.withConfig({
  displayName: "VisualPickerstyles__VisualPicker",
  componentId: "sc-1ui60so-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;padding:", "px;"], function (props) {
  return props.spacing / 2;
});
var VisualPickerOption = styled.div.withConfig({
  displayName: "VisualPickerstyles__VisualPickerOption",
  componentId: "sc-1ui60so-1"
})(["display:flex;flex-direction:column;position:relative;margin:", "px;width:", ";min-width:180px;&:not(.", "-visualpickerOption--disabled):hover{.", "-visualpicker__check{background-color:var(--dentsu-color-white);color:", ";opacity:1;}}&.", "-visualpickerOption--selected{&:hover{.", "-visualpicker__check{color:", ";}}}&::before{transition:all var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);background-color:", ";content:'';position:absolute;top:1px;right:1px;bottom:1px;left:1px;z-index:0;}&:hover::before{background-color:", ";}&.", "-visualpickerOption--selected::before{background-color:", ";top:0;right:0;bottom:0;left:0;}&.", "-visualpickerOption--disabled{opacity:0.4;cursor:not-allowed;}&.", "-visualpickerOption--hasError::before{background-color:", ";background-image:none;top:1px;right:1px;bottom:1px;left:1px;}"], function (props) {
  return props.spacing / 2;
}, function (props) {
  return "calc(".concat(100 / props.cols, "% - ").concat(props.spacing, "px)");
}, prefix, prefix, checkStyles.color.hover, prefix, prefix, checkStyles.color.selected, borderStyles.backgroundColor.resting, borderStyles.backgroundColor.hover, prefix, borderStyles.backgroundColor.selected, prefix, prefix, borderStyles.backgroundColor.hasError);
var VisualPickerLabel = styled.label.withConfig({
  displayName: "VisualPickerstyles__VisualPickerLabel",
  componentId: "sc-1ui60so-2"
})(["transition:all var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);background-color:", ";border:3px solid var(--dentsu-color-white);flex:1;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;position:relative;z-index:1;margin:var(--dentsu-spacing-2);padding:var(--dentsu-spacing-24);&:hover{background-color:", ";cursor:pointer;}.", "-visualpickerOption--selected &{background-color:", ";}.", "-visualpickerOption--hasError &{background-color:", ";}.", "-visualpickerOption--disabled &{pointer-events:none;}input{position:absolute !important;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);white-space:nowrap;}"], surfaceStyles.backgroundColor.resting, surfaceStyles.backgroundColor.hover, prefix, surfaceStyles.backgroundColor.selected, prefix, surfaceStyles.backgroundColor.hasError, prefix);
var Check = styled.div.withConfig({
  displayName: "VisualPickerstyles__Check",
  componentId: "sc-1ui60so-3"
})(["transition:all var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);color:", ";position:absolute;top:0;right:0;z-index:1;width:24px;height:24px;display:flex;align-items:center;justify-content:center;opacity:0;.", "-visualpickerOption--selected &{background-color:var(--dentsu-color-white);color:", ";opacity:1;}.", "-visualpickerOption--hasError.", "-visualpickerOption--selected &{color:", ";}"], checkStyles.color.resting, prefix, checkStyles.color.selected, prefix, prefix, checkStyles.color.hasError);
var Image = styled.img.withConfig({
  displayName: "VisualPickerstyles__Image",
  componentId: "sc-1ui60so-4"
})(["width:100%;height:100px;object-fit:scale-down;margin:0;"]);
var Title = styled.div.withConfig({
  displayName: "VisualPickerstyles__Title",
  componentId: "sc-1ui60so-5"
})(["position:relative;z-index:2;margin:", ";width:100%;color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-12);font-weight:var(--dentsu-font-weight-regular);text-align:center;word-break:break-word;strong{color:var(--dentsu-color-n850);display:block;font-size:var(--dentsu-font-size-16);font-weight:var(--dentsu-font-weight-semibold);margin-bottom:var(--dentsu-spacing-8);}"], function (props) {
  return props.hasImage ? '16px 0 auto 0' : 'auto 0';
});
export var Styled = {
  Check: Check,
  VisualPicker: VisualPicker,
  VisualPickerOption: VisualPickerOption,
  VisualPickerLabel: VisualPickerLabel,
  Image: Image,
  Title: Title
};